import { Flex, rem, Text } from '@mantine/core';
import { Row } from '@tanstack/react-table';
import { DealClassifierTct } from '@dealstack/shared/lib/generated';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

const INDENTATION_PER_LEVEL_PX = 16;

interface Props {
	value: string;
	row: Row<DealClassifierTct>;
}

export const ExpandableNameCell: React.FC<Props> = ({ value, row }) => {
	const canExpand = row.getCanExpand();
	const isExpanded = row.getIsExpanded();
	const depth = row.depth;

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (canExpand) {
			row.toggleExpanded();
		}
	};

	return (
		<Flex
			align="center"
			gap="xs"
			w="100%"
			miw="0"
			pl={`${rem(depth * INDENTATION_PER_LEVEL_PX)}`}
		>
			<Icon
				style={{ visibility: canExpand ? 'visible' : 'hidden' }}
				variant={isExpanded ? 'caret-down' : 'caret-right'}
				size="lg"
				color={defaultTheme.v3.colors.black[0]}
				onClick={handleClick}
			/>
			<Text
				size="B6Medium"
				style={{
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					flex: 1,
				}}
			>
				{value}
			</Text>
		</Flex>
	);
};
